import { render, staticRenderFns } from "./IconDraw.vue?vue&type=template&id=5939d768&"
import script from "./IconDraw.vue?vue&type=script&lang=js&"
export * from "./IconDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports